(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /*
    Hover to open the desktop mega menu.

    Dawn's top-level nav items are <details> elements, so they only open on
    click. On a pointer device wide enough for the inline nav (the drawer takes
    over below 1340px) we open on hover instead and close when the pointer
    leaves the whole nav. The panels are DOM children of the nav, so moving from
    a summary down into its panel never leaves the nav and never closes it.

    Touch, keyboard and narrow viewports are untouched: the media query gates
    every listener, and click/Enter still toggle as before.
  */
  (() => {
    const DESKTOP = '(min-width: 1340px) and (hover: hover) and (pointer: fine)';
    const TOP_ITEM = '.header__inline-menu > .list-menu > li > header-menu > details';
    const CLOSE_DELAY = 120;

    const isDesktop = () => window.matchMedia(DESKTOP).matches;

    let closeTimer = null;
    const cancelClose = () => {
      if (closeTimer) {
        clearTimeout(closeTimer);
        closeTimer = null;
      }
    };

    const setOpen = (details, open) => {
      if (!details || details.open === open) return;
      details.open = open;
      const summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    };

    /*
      Anchor the open panel under the item it was opened from.

      The panels are absolutely positioned against the nav, so with a flat
      `left: 0` a right-hand item like About opened its panel over on the left.
      The diagonal trip across to it left the header wrapper and closed the
      menu before the pointer arrived.

      Left-align the panel to its own summary instead, then clamp so a wide
      panel still cannot run off either edge. The clamp only ever pulls a panel
      left, and every panel is wider than its summary, so the summary always
      stays over the panel it opened - the pointer can drop straight down.
    */
    const GUTTER = 20;

    const panelOf = (details) => details.querySelector(':scope > .header__submenu');

    const place = (nav, details) => {
      const panel = panelOf(details);
      const summary = details.querySelector(':scope > summary');
      if (!panel || !summary) return;
      const maxLeft = window.innerWidth - GUTTER - panel.offsetWidth;
      const left = Math.max(GUTTER, Math.min(summary.getBoundingClientRect().left, maxLeft));
      panel.style.left = Math.round(left - nav.getBoundingClientRect().left) + 'px';
    };

    const unplace = (details) => {
      const panel = panelOf(details);
      if (panel) panel.style.left = '';
    };

    const init = (nav) => {
      if (!nav || nav.dataset.hoverNav === 'true') return;
      nav.dataset.hoverNav = 'true';

      const closeAll = (except) => {
        nav.querySelectorAll(TOP_ITEM + '[open]').forEach((details) => {
          if (details === except) return;
          setOpen(details, false);
          unplace(details);
        });
      };

      nav.addEventListener('mouseover', (event) => {
        if (!isDesktop()) return;
        const details = event.target.closest(TOP_ITEM);
        cancelClose();
        closeAll(details);
        if (!details) return;
        setOpen(details, true);
        place(nav, details);
      });

      // A panel opened by click or keyboard needs anchoring too, and its width
      // is only measurable once it is open.
      nav.addEventListener('toggle', (event) => {
        const details = event.target.closest(TOP_ITEM);
        if (!details) return;
        if (details.open && isDesktop()) place(nav, details);
        else unplace(details);
      }, true);

      window.addEventListener('resize', () => {
        nav.querySelectorAll(TOP_ITEM).forEach((details) => {
          if (details.open && isDesktop()) place(nav, details);
          else unplace(details);
        });
      });

      // The panel hangs below the nav's own box, so leaving the nav row
      // downwards would cross a strip of header before reaching it. Watching
      // the whole header wrapper means that strip never closes the panel; the
      // panel is a DOM descendant, so entering it is never a leave either.
      const leaveTarget = nav.closest('.header-wrapper') || nav;
      const scheduleClose = () => {
        cancelClose();
        closeTimer = setTimeout(() => closeAll(), CLOSE_DELAY);
      };

      leaveTarget.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        scheduleClose();
      });

      // Moving off the nav to the logo, search or cart still closes it.
      leaveTarget.addEventListener('mouseover', (event) => {
        if (!isDesktop() || nav.contains(event.target)) return;
        scheduleClose();
      });

      // A real mouse click on a summary would toggle the panel shut under the
      // pointer, leaving it closed until the pointer moves away and back.
      // event.detail is 0 for keyboard-triggered clicks, which stay untouched.
      nav.addEventListener('click', (event) => {
        if (!isDesktop() || event.detail === 0) return;
        const summary = event.target.closest('summary');
        if (!summary) return;
        const details = summary.closest(TOP_ITEM);
        if (details && details.open) event.preventDefault();
      });
    };

    const start = () => init(document.querySelector('.header__inline-menu'));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    // The theme editor re-renders the header section on every change.
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();
})();
